import { PrivacyIcon, PowerBiIcon } from "../../icons";
import "./NoAccess.scss";

const HELP_PORTAL_URL = "https://eyt.service-now.com/ey";

function NoAccess({ powerBiLink }) {
  return (
    <div className="no-access">
      <div className="no-access__glow" />
      <div className="no-access__card">
        <div className="no-access__badge">
          <div className="no-access__badge-ring">
            <div className="no-access__badge-inner">
              <PrivacyIcon />
            </div>
          </div>
        </div>

        <div className="no-access__body">
          <h2 className="no-access__title">No Information Available</h2>
          <p className="no-access__message">
            There is currently no information to display. This may be because
            you do not have the required permissions or there are no orders
            assigned to your profile.
          </p>
        </div>

        {powerBiLink && (
          <a
            href={powerBiLink}
            target="_blank"
            rel="noopener noreferrer"
            className="no-access__dashboard-btn"
          >
            <PowerBiIcon />
            Go to Dashboard
          </a>
        )}

        <div className="no-access__footer">
          <span className="no-access__footer-dot" />
          <p className="no-access__footer-text">
            Need help?{" "}
            <a
              href={HELP_PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="no-access__link"
            >
              Submit a request through the Help Portal
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default NoAccess;
